import { render } from "./subordinate.vue?vue&type=template&id=7163d4da&scoped=true"
import script from "./subordinate.vue?vue&type=script&lang=js"
export * from "./subordinate.vue?vue&type=script&lang=js"

import "./subordinate.vue?vue&type=style&index=0&id=7163d4da&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7163d4da"

export default script